import { apiProjects$ } from "../api/projects";
import { Project } from "../models/project";
import { ModalService } from "../services/modal.service";
import { Component } from "./component";

export class ProjectsComponent extends Component {
  public static htmlDefinition = 'app-projects';
  private pagesize = 2;

  get type() {
    return this.getAttribute('type') ?? 'project';
  }

  private locale: 'pl' | 'en' = 'pl';

  get eventToListen() {
    return this.getAttribute('event') ?? this.type + '_load_more';
  }

  private projects: Project[] = [];
  private renderedProjects: number[] = [];

  private generateProjects(clearInnerHtml = true): boolean {
    if (clearInnerHtml) {
      this.innerHTML = '';
    }

    const prevLenght = this.renderedProjects.length;
    for (let i = (this.renderedProjects[this.renderedProjects.length - 1] ?? -1) + 1; i < this.projects.length && this.renderedProjects.length < prevLenght + this.pagesize; i++) {
      const project = this.projects[i];
      if (project.type === this.type) {
        const projectLocale = project[this.locale];
        this.innerHTML += `<div data-project-id="${i}"><picture><source srcset="img/project_${project.id}.webp" type="image/webp"><source srcset="img/project_${project.id}.png" type="image/jpeg"><img decoding="async" fetchpriority="low" loading="lazy" src="img/project_${project.id}.png" height="100%" width="100%" alt="Adrian Kokot - realizacja '${projectLocale.name}'"></picture><div><h3>${projectLocale.name}</h3><p>${projectLocale.shortDescription}</p></div></div>`;
        this.renderedProjects.push(i);
      }
    }

    this.querySelectorAll('img:not(.loaded)').forEach(el => {
      el.addEventListener('load', e => {
        el.classList.add('loaded');
      });
    });

    return this.projects.filter(x => x.type === this.type).length !== this.renderedProjects.length;
  }

  public more(): boolean {
    return this.generateProjects(false);
  }

  constructor() {
    super();

    this.locale = document.querySelector('[lang]')?.getAttribute('lang') === 'en' ? 'en' : 'pl';

    this.addEventListener('click', e => {

      if (e.target != this) {
        let target: HTMLElement = e.target as HTMLElement;
        while (target != this && target.parentElement != this) {
          target = target.parentElement as HTMLElement
        }

        const clickedId = parseInt(target.dataset.projectId ?? '-1');
        if (clickedId != -1) {
          ModalService.openModal({
            title: this.projects[clickedId][this.locale].name,
            content: this.generateModalContentFromProject(this.projects[clickedId])
          });
        }
      }
    });

    window.addEventListener(this.eventToListen, e => {
      if (!this.more()) {
        const button = (e as CustomEvent).detail.button as Element;
        button.classList.value = 'text-gray-400 cursor-not-allowed duration-300 transition-colors';
      }
    });

    apiProjects$.subscribe((value: Project[]) => {
      this.projects = value;
      if (this.projects.length > 0) {
        this.generateProjects();
      }
    });
  }

  private generateModalContentFromProject(project: Project): string {

    let modalContent = '';

    modalContent += '<p>' + project[this.locale].descriptionSections.join('</p><p>') + '</p>';

    modalContent += this.locale === 'pl' ? '<h5>Użyte technologie</h5>' : '<h5>Used stack</h5>';

    modalContent += '<p>' + project.techStack.map(t => `<span class="${t.color}">${t.name}</span>`).join('') + '</p>';

    return modalContent;
  }
}